import React, { Children, useEffect } from 'react';
import { useState } from 'react';
import { FiCheck } from "react-icons/fi";
import './styles.scss';

const AnimatedButton = ({onClick, validated, cancelled, children}) => {

    const [clicked, setClicked] = useState(false); 
    const [validate, setValidate] = useState(false);

    useEffect(()=>{

        //this is so that the button self cancels the animation after 1 second

        if(validated){

            setValidate(true);
            setClicked(false);

            setTimeout(()=>{
                setValidate(false);
            },1000);
        }else{
            setValidate(false);
        }
    },[validated]);

    const handleClick = (event) => {

        event.preventDefault(); 
        event.stopPropagation(); 

        setClicked(true);

        if(typeof onClick === 'function'){

            onClick(event); 
        }
    }

    const generateClass = () => {

        let className = ''; 

        console.log('generate class, cancelled: ', cancelled);

        if(cancelled){

            return '';
        }

        if(clicked && !validate){

            className='load';

        }else if(validate) {

            if(clicked){
                //cancel click
                setClicked(false);
            }

            console.log('validated');

            className='validate'; 
        }

        console.log('validated: ',validate,'className: ', className);

        return className; 
    }

    return (
        <div className={`animatedButtonContainer`}>
            <button className={'animatedButton ' + generateClass()} onClick={handleClick}>
                {validate ? <FiCheck /> : children}
            </button>
        </div>
    );
}

export default AnimatedButton; 